import { useInfiniteQuery } from '@tanstack/react-query'

import { auditApi } from '../../api/audit-api'

export function useUserAuditHistory(entityId: string, userId: string) {
  return useInfiniteQuery({
    queryKey: ['audit', 'user', entityId, userId],
    staleTime: 0,
    initialPageParam: '',
    queryFn: ({ pageParam }) => auditApi.userHistory(entityId, userId, pageParam),
    getNextPageParam: (lastPage) => lastPage.pageInfo.hasNextPage ? lastPage.pageInfo.endCursor ?? undefined : undefined,
  })
}
